module.exports = __webpack_public_path__ + "img/small_SRT406.2235a299.png";